<template>
    <entity-list entity="rumour" api-name="rumours" :use-events="false" :team-id="teamId" isArchive>
        <template v-slot:[`currentList`]="{ entities, searchTerm, readRoute }">
            <v-data-table
                :headers="headers"
                :items="entities"
                :items-per-page="15"
                dense
                class="elevation-1"
                :search="searchTerm"
                :footer-props="{
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:[`item.name`]="{ item }">
                    <router-link :to="{ name: readRoute, params: { id: item.keyId } }" :title="item.name">
                        {{ item.name }}
                    </router-link>
                </template>
            </v-data-table>
        </template>
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
export default {
    name: 'MonsterList',
    components: {
        'entity-list': EntityList,
    },
    props: {
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
    data() {
        return {
            researchPeriods: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '25%',
                },
                { text: 'Rumour Type', value: 'rumourTypeText' },
                { text: 'Main Team', value: 'teamName', filterable: false, width: '20%' },
                { text: 'Archive Date', value: 'archiveDate', filterable: false, width: '20%' },
            ],
        }
    },
}
</script>
